import React from 'react'
import { WarningFilled } from '@ant-design/icons'
import { T } from '@transifex/react'
import { Popover } from 'src/antd'

import { APIURLS, baseUrl } from 'src/api/baseUrl'
import { Typography } from 'src/storybook/components'
import { orange500 } from 'src/styles/color-theme'
import { extractDomain } from 'src/utils/urls'

export const CurrentUrlStatus = () => {
  const isProductionApi = extractDomain(baseUrl) === APIURLS.production

  return (
    <>
      {!isProductionApi && (
        <Popover
          getPopupContainer={() => document.body}
          placement="bottomLeft"
          content={
            <Typography variant="subHeader-16">
              <T _str="You are using api url:" />{' '}
              <Typography code>{baseUrl}</Typography>
            </Typography>
          }
        >
          <WarningFilled className="header-icon" style={{ color: orange500 }} />
        </Popover>
      )}
    </>
  )
}
